//
//
//
//
//
//
//
//
//
//
//
//

import intercomBubble from '~/components/IntercomBubble/IntercomBubble';

export default {
  components: {
    intercomBubble,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      personalizationData: {},
      timeInPage: 1,
      intercomBubbleId: null,
      showIntercomBubble: false,
      intercomBubbleContact: 'anima',
      intercomBubbleMessage:
        'Hi 👋<br />We have a special offer for September only!<br /><b>50% off the first 3 months</b>, click here to redeem',
      timeoutIds: [],
      isAnnual: true,
      isMobile: false,
      isPricingScreenFlowActive: false,
      stigg: null,
      countryCode: 'US',
    };
  },
  computed: {
    contactUsUrl() {
      const resultUrl = new URL('https://anima-storybook.typeform.com/to/Vkt8zmCd');
      if (process.client) {
        const currentSearchParams = new URLSearchParams(window?.location.search);
        for (const [key, value] of currentSearchParams.entries()) {
          resultUrl.searchParams.set(key, value);
        }
      }
      return resultUrl.toString();
    },
    activeExperimentName() {
      if (this.isPricingScreenFlowActive) {
        return 'pricing_screen_flow';
      }
      return null;
    },
  },
  mounted() {
    if (!this.stigg) {
      this.stigg = Stigg({ apiKey: process.env.stiggToken });
    }
    this.getUserCountryCode().then((countryCode) => {
      this.countryCode = countryCode;

      const paywall = this.stigg.Paywall({
        highlightedPlanId: 'plan-anima-pro',
        billingCountryCode: this.countryCode,
        textOverrides: {
          highlightChip: 'Popular',
          entitlementsTitle: (plan) => `${plan.displayName} includes`,
          planCTAButton: {
            startNew: 'Get plan',
            upgrade: 'Get plan',
            custom: 'Contact us'
          },
          price: {
            custom: 'Custom',
            priceNotSet: 'Price not set'
          }
        },
        preferredBillingPeriod: 'yearly',
        onPlanSelected: (args) => {
          const { intentionType, selectedBillingPeriod, plan } = args;
          this.$tracking.trackEvent('website.pricing.plan.selected', {
            planId: plan.id,
            planName: plan.displayName,
            billingPeriod: selectedBillingPeriod,
            intentionType,
            countryCode: this.countryCode,
          });
          if (intentionType === "REQUEST_CUSTOM_PLAN_ACCESS") {
            window.location.href = plan.metadata?.contactLink ?? this.contactUsUrl;
          } else {
            const redirectUrl = `https://dev.animaapp.com/pricing?plan=${plan.id}&billingPeriod=${selectedBillingPeriod}`;
            const signupUrl = new URL('https://projects.animaapp.com/signup');
            signupUrl.searchParams.set('redirect', redirectUrl);
            signupUrl.searchParams.set('platform', 'dev-anima');
            signupUrl.searchParams.set('passOnBoarding', 'true');
            window.location.href = signupUrl.toString();
          }
        },
        shouldHidePlan: (plan) => {
          return plan.id === 'plan-anima-pro-promotion';
        },
      });
      paywall.mount('#paywall');
    });

    this.$intercom('boot');
    this.checkTimeZoneFeatures();
    this.timeoutIds.push(
      setTimeout(this.promptIntercomBubble, this.timeInPage * 1000)
    );
    const personalizationData = fetch('https://api.animaapp.com/rpc/get_personalization_data', {
      method: 'GET'
    }
    ).then((response) => response.json());
    this.personalizationData = personalizationData;
  },

  beforeDestroy() {
    this.clearTimeouts();
    this.$intercom('shutdown');
    this.hideIntercomBubble();
  },
  methods: {
    async getUserCountryCode() {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2500);

      try {
        const response = await fetch('https://ipapi.co/json/', {
          signal: controller.signal,
        });

        const payload = await response.json();
        return payload.country_code || 'US';
      } catch {
        return 'US';
      } finally {
        clearTimeout(timeoutId);
      }
    },
    async checkTimeZoneFeatures() {
      const featureName = 'tz.show.pricing-screen-based-flow';
      const date = new Date();
      const offset = date.getTimezoneOffset();
      const hour = (-1 * offset) / 60;
      const params = {
        hour,
        feature: featureName,
      };
      const resp = await this.$animaapi.get('/get_time_zone_feature_flags', {
        params,
      });
      const experiments = {};
      Object.entries(resp.data || {}).map(
        ([feature, enabled]) => (experiments[feature] = enabled === 'TRUE')
      );
      if (experiments[featureName]) {
        localStorage.setItem('pricingScreenFlowActive', true);
      }
      const pricingScreenFlowActive = localStorage.getItem(
        'pricingScreenFlowActive'
      );
      this.isPricingScreenFlowActive = !!(
        pricingScreenFlowActive || experiments[featureName]
      );
    },
    trackIdleTime({ timeInPage }) {
      this.$tracking.trackEvent('website.page.idle', {
        timeInPage,
        screenWidth: window?.innerWidth,
        page: 'pricing',
      });
    },
    promptIntercomBubble() {
      if (new Date() < new Date('2021-10-01')) {
        const { timeInPage } = this;
        this.showIntercomBubble = true;
        this.trackIdleTime({ timeInPage });
      }
    },
    hideIntercomBubble() {
      this.showIntercomBubble = false;
    },
    clearTimeouts() {
      for (const id of this.timeoutIds) {
        clearTimeout(id);
      }
    },
    goToWebappPayment() {
      window.location.href =
        'https://projects.animaapp.com/payment?plan=pro&interval=monthly&promo_code=sep-2021-offer';
    },
    trackContactUs() {
      this.$tracking.trackEvent('pricing.contact-us.click');
    },
  },
};
